import { render } from "./calendar_notification.vue?vue&type=template&id=7b53be9a"
import script from "./calendar_notification.vue?vue&type=script&lang=js"
export * from "./calendar_notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__